import { computed } from 'vue'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

interface KanbanLogDeadlinePayload {
  oldValue: string | null
  value: string | null
}

interface KanbanLogDeadlineReturn {
  refOldDate: ComputedRef<string>
  refNewDate: ComputedRef<string>
}

const formatDate = (raw: string | null): string => {
  if (!raw) return ''
  const parsed = dayjs(raw)
  return parsed.isValid() ? parsed.format(DateFormat.KanbanDate) : raw
}

export const useKanbanLogDeadline = (payload: KanbanLogDeadlinePayload): KanbanLogDeadlineReturn => {
  const refOldDate = computed<string>(() => formatDate(payload.oldValue))
  const refNewDate = computed<string>(() => formatDate(payload.value))

  return {
    refOldDate,
    refNewDate,
  }
}